'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _ = require('.');

var _Placeholder = require('../SvgIcon/Placeholder');

var _Placeholder2 = _interopRequireDefault(_Placeholder);

var _Text = require('../Text');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _typography = require('../styles/typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = (0, _jssThemeReactor.createStyleSheet)('SearchListItem', function (theme) {
  var _Object$assign;

  return Object.assign({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      overflow: 'hidden',
      paddingBottom: theme.typography.rhythmByUnit(1),
      paddingTop: theme.typography.rhythmByUnit(1)
    },
    content: {
      minHeight: theme.typography.rhythmByUnit(6)
    },
    contentWrap: {
      marginBottom: theme.typography.rhythmByUnit(1)
    },
    contentColumn: {
      display: 'flex',
      justifyContent: 'center'
    },
    iconBox: {
      flex: '0 0 ' + theme.typography.rhythmByUnit(4),
      marginRight: theme.typography.rhythmByUnit(2),
      fontSize: theme.typography.rhythmByUnit(4),
      display: 'inline-flex',
      alignItems: 'center',
      textAlign: 'center'
    },
    dense: {
      paddingBottom: 0,
      paddingTop: 0
    },
    icon: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      height: theme.typography.rhythmByUnit(6),
      minWidth: theme.typography.rhythmByUnit(6),
      width: theme.typography.rhythmByUnit(6)
    },
    iconLabelBox: {
      flex: '0 0 ' + theme.typography.rhythmByUnit(13),
      flexDirection: 'column',
      marginRight: theme.typography.rhythmByUnit(2)
    },
    contentBox: {
      flex: '1 1 auto',
      display: 'flex',
      flexDirection: 'column',
      minHeight: theme.typography.rhythmByUnit(6),
      overflow: 'hidden'
    },
    primaryText: {
      flex: '1 1 auto',
      overflow: 'hidden',
      alignSelf: 'center'
    },
    primary: {
      flex: '1 0 auto'
    },
    secondary: {},
    actionsBox: {
      display: 'flex',
      flex: '0 0 auto'
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'hidden',
      marginBottom: theme.typography.rhythmByUnit(1),
      '& > *': {
        marginRight: theme.typography.rhythmByUnit(1)
      }
    },
    dash: Object.assign({
      alignSelf: 'center'
    }, theme.typography.body1),
    truncate: theme.mixins.truncate(),
    skeletonRoot: theme.mixins.skeletonRandom(),
    skeletonIcon: Object.assign({
      borderRadius: theme.variables.borderRadius,
      color: 'transparent'
    }, theme.mixins.skeleton()),
    skeletonPrimary: Object.assign({
      height: theme.typography.fontSize
    }, theme.mixins.skeleton()),
    skeletonSecondary: Object.assign({
      marginBottom: theme.typography.rhythmByUnit(1),
      height: theme.typography.fontSize
    }, theme.mixins.skeleton())
  }, theme.animations.skeleton(), (_Object$assign = {}, _defineProperty(_Object$assign, theme.breakpoints.up('sm'), {
    detail: {
      marginTop: theme.typography.rhythmByUnit(-1)
    }
  }), _defineProperty(_Object$assign, theme.breakpoints.down('sm'), {
    iconLabelBox: {
      display: 'none'
    },
    dash: {
      display: 'none'
    },
    primaryText: {
      flexDirection: 'column',
      display: 'flex'
    }
  }), _Object$assign));
});

var SearchListItem = (_temp = _class = function (_PureComponent) {
  _inherits(SearchListItem, _PureComponent);

  function SearchListItem() {
    _classCallCheck(this, SearchListItem);

    return _possibleConstructorReturn(this, (SearchListItem.__proto__ || Object.getPrototypeOf(SearchListItem)).apply(this, arguments));
  }

  _createClass(SearchListItem, [{
    key: 'render',
    value: function () {
      function render() {
        var _classNames4, _classNames5, _classNames6;

        var _props = this.props,
            actions = _props.actions,
            chipHeight = _props.chipHeight,
            chips = _props.chips,
            className = _props.className,
            dense = _props.dense,
            detailPrimary = _props.detailPrimary,
            detailSecondary = _props.detailSecondary,
            detailTertiary = _props.detailTertiary,
            icon = _props.icon,
            iconIsAvatar = _props.iconIsAvatar,
            iconLabel = _props.iconLabel,
            iconStyle = _props.iconStyle,
            primary = _props.primary,
            secondary = _props.secondary,
            skeleton = _props.skeleton,
            style = _props.style,
            wrap = _props.wrap,
            other = _objectWithoutProperties(_props, ['actions', 'chipHeight', 'chips', 'className', 'dense', 'detailPrimary', 'detailSecondary', 'detailTertiary', 'icon', 'iconIsAvatar', 'iconLabel', 'iconStyle', 'primary', 'secondary', 'skeleton', 'style', 'wrap']);

        if (skeleton) {
          actions = [];
          icon = _react2['default'].createElement(_Placeholder2['default'], null);
          iconLabel = undefined;
          primary = ' ';
          secondary = undefined;
          detailPrimary = ' ';
          detailSecondary = undefined;
          detailTertiary = undefined;
          chips = [];
        }

        var hasActions = actions && (actions.length || (0, _react.isValidElement)(actions));
        var classes = this.context.styleManager.render(styleSheet);

        var iconBoxClass = (0, _classnames2['default'])(classes.iconBox, _defineProperty({}, classes.skeletonIcon, skeleton), classes.contentColumn);
        var iconLabelBoxClass = (0, _classnames2['default'])(classes.iconLabelBox, classes.contentColumn);
        var primaryContentClass = (0, _classnames2['default'])(classes.content, _defineProperty({}, classes.contentWrap, wrap), classes.contentColumn);
        var primaryClass = (0, _classnames2['default'])(classes.primary);
        var secondaryClass = (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap), classes.secondary);
        var contentBoxClass = (0, _classnames2['default'])(classes.contentBox, classes.contentColumn);
        var primaryTextClass = (0, _classnames2['default'])((_classNames4 = {}, _defineProperty(_classNames4, classes.truncate, !wrap), _defineProperty(_classNames4, classes.skeletonPrimary, skeleton), _classNames4), classes.primaryText);
        var detailTextClass = (0, _classnames2['default'])((_classNames5 = {}, _defineProperty(_classNames5, classes.truncate, !wrap), _defineProperty(_classNames5, classes.skeletonSecondary, skeleton), _classNames5));
        var rootClassName = (0, _classnames2['default'])(classes.root, (_classNames6 = {}, _defineProperty(_classNames6, classes.dense, dense), _defineProperty(_classNames6, classes.skeletonRoot, skeleton), _classNames6), className);

        var iconComponent = !icon ? null : _react2['default'].cloneElement(icon, {
          className: (0, _classnames2['default'])(iconBoxClass, icon.props.className)
        });
        var iconLabelComponent = !iconLabel || !icon ? null : _react2['default'].createElement(
          'div',
          { className: iconLabelBoxClass },
          (0, _react.isValidElement)(iconLabel) ? _react2['default'].cloneElement(iconLabel, {
            className: (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap), iconLabel.props.className)
          }) : _react2['default'].createElement(
            _Text.Body2,
            { className: (0, _classnames2['default'])(_defineProperty({}, classes.truncate, !wrap)) },
            iconLabel
          )
        );
        var primaryComponent = !primary ? null : (0, _react.isValidElement)(primary) ? _react2['default'].cloneElement(primary, {
          className: (0, _classnames2['default'])(primaryClass, primary.props.className)
        }) : _react2['default'].createElement(
          _Text.Body2,
          {
            component: 'span',
            className: (0, _classnames2['default'])(primaryClass, _defineProperty({}, classes.truncate, !wrap))
          },
          primary
        );
        var secondaryComponent = !secondary ? null : (0, _react.isValidElement)(secondary) ? _react2['default'].cloneElement(secondary, {
          className: (0, _classnames2['default'])(secondaryClass, secondary.props.className)
        }) : _react2['default'].createElement(
          _Text.Body1,
          { component: 'span', className: secondaryClass },
          secondary
        );
        var primaryContentComponent = !primary && !secondary && !hasActions ? null : _react2['default'].createElement(
          'div',
          { className: primaryContentClass },
          _react2['default'].createElement(
            'div',
            { className: primaryTextClass },
            primaryComponent,
            primaryComponent && secondaryComponent && _react2['default'].createElement(
              'span',
              { className: classes.dash },
              '\xA0\u2014\xA0'
            ),
            secondaryComponent
          ),
          hasActions && _react2['default'].createElement(
            'div',
            { className: classes.actionsBox },
            actions
          )
        );
        var detailPrimaryComponent = !detailPrimary ? null : (0, _react.isValidElement)(detailPrimary) ? _react2['default'].cloneElement(detailPrimary, {
          className: (0, _classnames2['default'])(detailTextClass, detailPrimary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailPrimary
        );
        var detailSecondaryComponent = !detailSecondary ? null : (0, _react.isValidElement)(detailSecondary) ? _react2['default'].cloneElement(detailSecondary, {
          className: (0, _classnames2['default'])(detailTextClass, detailSecondary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailSecondary
        );
        var detailTertiaryComponent = !detailTertiary ? null : (0, _react.isValidElement)(detailTertiary) ? _react2['default'].cloneElement(detailTertiary, {
          className: (0, _classnames2['default'])(detailTextClass, detailTertiary.props.className)
        }) : _react2['default'].createElement(
          'div',
          { className: detailTextClass },
          detailTertiary
        );
        var chipsComponent = !chips.length ? null : _react2['default'].createElement(
          'div',
          { className: classes.chips, style: { height: chipHeight } },
          chips
        );

        return _react2['default'].createElement(
          _.ListItem,
          _extends({
            className: rootClassName,
            divider: true
          }, Object.assign({ dense: dense, style: style }, other)),
          icon && _react2['default'].createElement(
            'div',
            { className: classes.icon },
            iconComponent,
            iconLabelComponent
          ),
          _react2['default'].createElement(
            'div',
            { className: contentBoxClass },
            primaryContentComponent,
            (detailPrimaryComponent || detailSecondaryComponent || detailTertiaryComponent) && _react2['default'].createElement(
              _Text.Body1,
              {
                component: 'div',
                paragraph: true,
                secondary: true,
                className: classes.detail
              },
              detailPrimaryComponent,
              detailSecondaryComponent,
              detailTertiaryComponent
            ),
            chipsComponent
          )
        );
      }

      return render;
    }()
  }]);

  return SearchListItem;
}(_react.PureComponent), _class.propTypes = {
  /**
   * icon node
   */
  icon: _PropTypes2['default'].node,
  /**
   * inline icon style
   */
  iconStyle: _PropTypes2['default'].object,
  /**
   * icon label text/node
   */
  iconLabel: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  use a larger icon with a rounded border
   */
  iconIsAvatar: _PropTypes2['default'].deprecate(_PropTypes2['default'].bool),
  /**
   * primary text/node
   */
  primary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   * secondary text/node
   */
  secondary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail primary text/node
   */
  detailPrimary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail secondary text/node
   */
  detailSecondary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  detail tertiary text/node
   */
  detailTertiary: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].node]),
  /**
   *  array of action buttons
   */
  actions: _PropTypes2['default'].oneOfType([_PropTypes2['default'].node, _PropTypes2['default'].arrayOf(_PropTypes2['default'].node)]),
  /**
   *  array of chips
   */
  chips: _PropTypes2['default'].arrayOf(_PropTypes2['default'].node),
  /**
   *  chip height (necessary to properly hide overflow chips); defaults to default chip height
   */
  chipHeight: _PropTypes2['default'].string,
  /**
   *  class name to apply to the root element
   */
  className: _PropTypes2['default'].string,
  /**
   *  use more space around each list item
   */
  dense: _PropTypes2['default'].bool,
  /**
   *  Use skeleton styling
   */
  skeleton: _PropTypes2['default'].bool,
  /**
   *  Override the inline-styles of the root element.
   */
  style: _PropTypes2['default'].object,
  /**
   *  whether text will wrap inside SearchListItem
   */
  wrap: _PropTypes2['default'].bool
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  iconStyle: {},
  actions: [],
  chips: [],
  chipHeight: (0, _typography.rhythmByUnit)(4),
  iconIsAvatar: false,
  dense: true,
  wrap: false
}, _class.muiName = 'SearchListItem', _temp);
exports['default'] = SearchListItem;


SearchListItem.displayName = 'SearchListItem';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/SearchListItem.js
// module id = 255
// module chunks = 32